<div class="layout-col full gap-xl">
  <app-constraint-spec-detail
    class="flex"
    [constraintSpec]="constraint"
    (close)="onClose($event)"
    (save)="onSave($event)"
  >
  </app-constraint-spec-detail>
</div>
